// extracted by mini-css-extract-plugin
export default {"overlay":"tz-z","bodyOpen":"uz-z","content":"vz-z","header":"wz-z","close":"xz-z","closeNoHeading":"yz-z"};